module.exports = __webpack_public_path__ + "img/2.3a1e83e8.webp";